import { PropsWithChildren } from 'react';
import { useIsLoadingDelayed } from '../../hooks';
import { Tooltip, TooltipContent } from '../Tooltip';

export interface DelayedLoadingTooltipProps extends PropsWithChildren {
  loading: boolean;
  content: React.ReactNode;
  delay?: number;
  TooltipContentProps?: React.ComponentProps<typeof TooltipContent>;
}

export const DelayedLoadingTooltip = ({
  loading,
  content,
  delay,
  children,
  TooltipContentProps,
}: DelayedLoadingTooltipProps) => {
  const showTooltip = useIsLoadingDelayed({ loading, delay });

  return (
    <Tooltip
      open={showTooltip}
      content={content}
      TooltipTriggerProps={{ asChild: true }}
      TooltipContentProps={TooltipContentProps}
    >
      {children}
    </Tooltip>
  );
};
